import { useIntl } from 'react-intl';

import { TerminalWorkflowType } from '../../../../api/terminals';
import ActionCard from '../../../../components/domain/ActionCard';
import { AllowedActionViewProps } from '../../../../components/domain/AllowedAction';
import useTerminal from '../../../../hooks/useTerminal';
import { isDelivery } from '../../../../services/contact/GlobalPermissions';
import { hasReturnsConfiguredData } from '../../../nike/CheckReturnsWorkflow';
import ReturnWorkflow from '../../../nike/ReturnWorkflow';
import { NikeRole, isNikeContactData } from '../../../nike/api';

type ReturnItemsActionProps = AllowedActionViewProps;

function ReturnItemsAction(props: ReturnItemsActionProps) {
    const intl = useIntl();
    const terminal = useTerminal();
    if (terminal === null || props.contact === undefined) return undefined;
    // Workflow needs to be IMES_DEXIS_NIKE or DELHAIZE and should not be a delivery
    if (!((terminal.workflow === TerminalWorkflowType.IMES_DEXIS_NIKE || terminal.workflow === TerminalWorkflowType.DELHAIZE) && !isDelivery(props.contact)))
        return undefined;
    if (!hasReturnsConfiguredData(terminal.additional_data)) {
        console.warn('Terminal is not configured for returns, skipping action CheckReturnsAction');
        return undefined;
    }

    const returnItemsAction: ActionCard = {
        actionText: intl.formatMessage({
            id: 'workflow.nike.DashboardWorkflow.ReturnItemsAction',
            description: 'This is the return action on the Nike dashboard',
            defaultMessage: 'Return item(s)',
        }),
        icon: <i className='bi bi-arrow-repeat dashboard-action-icon' />,
        view: (
            <ReturnWorkflow
                loggedInContact={props.contact}
                onHome={props.onHome}
                onInactivity={props.onInactivity}
                onLogout={props.onHome}
            />
        ),
    };

    return returnItemsAction;
}

export default ReturnItemsAction;
